/**
 * ./src/App.js
 *
 * This module serves as the **main entry point** of the React application.
 * It defines the **routing structure** using `react-router-dom` and
 * integrates **authentication**, **protected routes**, and **exercise modules**.
 *
 */

import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
// import { auth } from "./firebase/firebase";
import "./App.css";

// Import UI Components
import Landing from "./landing/Landing";
import Dashboard from "./dashboard/Dashboard";
import Exercise1 from "./exercise1/Exercise1";
import Exercise1Choosing from "./exercise1/Exercise1Choosing";
import Exercise1ChoosingNoPopup from "./exercise1/Exercise1ChoosingNoPopup";
import Exercise1Workout from "./exercise1/Exercise1Workout";
import Exercise1Finish from "./exercise1/Exercise1Finish";
import Auth from "./auth/Auth"; // Combined Auth page for both login and signup
import ProtectedRoute from "./auth/ProtectedRoute"; // Import ProtectedRoute component
import Exercise1Summary from "./exercise1/Exercise1Summary";
import Exercise1Failed from "./exercise1/Exercise1Failed";
import Exercise2Failed from "./exercise2/Exercise2Failed";
import Exercise3Failed from "./exercise3/Exercise3Failed";
import Exercise4Failed from "./exercise4/Exercise4Failed";
import Exercise5Failed from "./exercise5/Exercise5Failed";
import Exercise7Failed from "./exercise7/Exercise7Failed";
import Exercise8Failed from "./exercise8/Exercise8Failed";
import Exercise9Failed from "./exercise9/Exercise9Failed";
import Exercise10Failed from "./exercise10/Exercise10Failed";

import Exercise1FullyComplete from "./exercise1/Exercise1FullyComplete";
import Exercise2FullyComplete from "./exercise2/Exercise2FullyComplete";
import Exercise3FullyComplete from "./exercise3/Exercise3FullyComplete";
import Exercise4FullyComplete from "./exercise4/Exercise4FullyComplete";
import Exercise5FullyComplete from "./exercise5/Exercise5FullyComplete";
import Exercise7FullyComplete from "./exercise7/Exercise7FullyComplete";
import Exercise8FullyComplete from "./exercise8/Exercise8FullyComplete";
import Exercise9FullyComplete from "./exercise9/Exercise9FullyComplete";
import Exercise10FullyComplete from "./exercise10/Exercise10FullyComplete";

import Exercise1Intro from "./exercise1/Exercise1Intro";
import Exercise1Video from "./exercise1/Exercise1Video";
import Exercise2 from "./exercise2/Exercise2";
import Exercise2Intro from "./exercise2/Exercise2Intro";
import Exercise2Workout from "./exercise2/Exercise2Workout";
import Exercise2Finish from "./exercise2/Exercise2Finish";
import Exercise2Summary from "./exercise2/Exercise2Summary";
import Exercise3 from "./exercise3/Exercise3";
import Exercise3Intro from "./exercise3/Exercise3Intro";
import Exercise3Workout from "./exercise3/Exercise3Workout";
import Exercise3Finish from "./exercise3/Exercise3Finish";
import Exercise3Summary from "./exercise3/Exercise3Summary";
import Exercise4 from "./exercise4/exercise4";
import Exercise4Intro from "./exercise4/Exercise4Intro";
import Exercise4Workout from "./exercise4/Exercise4Workout";
import Exercise4Summary from "./exercise4/Exercise4Summary";
import Exercise4Finish from "./exercise4/Exercise4Finish";
import Exercise5 from "./exercise5/Exercise5";
import Exercise5Intro from "./exercise5/Exercise5Intro";
import Exercise5Workout from "./exercise5/Exercise5Workout";
import Exercise5Summary from "./exercise5/Exercise5Summary";
import Exercise5Finish from "./exercise5/Exercise5Finish";
import Exercise5Test from "./exercise5/Exercise5Test";
import Exercise6 from "./exercise6/Exercise6";
import Exercise6Intro from "./exercise6/Exercise6Intro";
import Exercise6Workout from "./exercise6/Exercise6Workout";
import Exercise6Summary from "./exercise6/Exercise6Summary";
import Exercise7 from "./exercise7/Exercise7";
import Exercise7Intro from "./exercise7/Exercise7Intro";
import Exercise7Workout from "./exercise7/Exercise7Workout";
import Exercise7Test from "./exercise7/Exercise7Test";
import Exercise7Summary from "./exercise7/Exercise7Summary";
import Exercise8 from "./exercise8/Exercise8";
import Exercise8Intro from "./exercise8/Exercise8Intro";
import Exercise8Workout from "./exercise8/Exercise8Workout";
import Exercise8Test from "./exercise8/Exercise8Test";
import Exercise8Summary from "./exercise8/Exercise8Summary";
import Exercise9 from "./exercise9/Exercise9";
import Exercise9Intro from "./exercise9/Exercise9Intro";
import Exercise9Workout from "./exercise9/Exercise9Workout";
import Exercise9Test from "./exercise9/Exercise9Test";
import Exercise9Summary from "./exercise9/Exercise9Summary";
import Exercise10 from "./exercise10/Exercise10";
import Exercise10Intro from "./exercise10/Exercise10Intro";
import Exercise10Workout from "./exercise10/Exercise10Workout";
import Exercise10Test from "./exercise10/Exercise10Test";
import Exercise10Summary from "./exercise10/Exercise10Summary";
import Warmup1 from "./warmup/Warmup1";
import Warmup2 from "./warmup/Warmup2";
import Warmup3 from "./warmup/Warmup3";
import Warmupfinish from "./warmup/Warmupfinish";
import Warmupwelcome from "./warmup/Warmupwelcome";
import Exercise8Warmup from "./exercise8/Exercise8Warmup";
import TawkToChat from "./TawkTo_ChatBox/TawkToChat";

// (Exercise 2 to 10 imports omitted for brevity, but follow the same structure)

/**
 * `App Component`
 * - Wraps the entire application with `Router`
 * - Defines **public & protected routes**
 * - Implements **dynamic routing** for exercises
 */

function App() {
  // Add a route guard for the root path
  const RootRedirect = () => {
    const token = localStorage.getItem("token");
    return token ? <Navigate to="/landing" /> : <Navigate to="/auth" />;

    // const [loading, setLoading] = React.useState(true);
    // const [isAuthenticated, setIsAuthenticated] = React.useState(false);

    // useEffect(() => {
    //   const unsubscribe = auth.onAuthStateChanged((user) => {
    //     if (user && user.emailVerified) {
    //       setIsAuthenticated(true);
    //       // Store username if not already stored
    //       if (!localStorage.getItem("username")) {
    //         const username = user.email.split("@")[0];
    //         localStorage.setItem("username", username);
    //       }
    //     } else {
    //       setIsAuthenticated(false);
    //     }
    //     setLoading(false);
    //   });

    //   return () => unsubscribe();
    // }, []);

    // if (loading) {
    //   return <div>Loading...</div>; // Or use your LoadingSpinner component
    // }

    // return isAuthenticated ? (
    //   <Navigate to="/landing" />
    // ) : (
    //   <Navigate to="/auth" />
    // );
  };

  return (
    <Router>
      <div className="App">
      {/* Add TawkToChat to all pages */}
      <TawkToChat />
        <Routes>
          {/* Root path handler */}
          <Route path="/" element={<RootRedirect />} />

          {/* Public Auth Route */}
          <Route path="/auth" element={<Auth />} />

          {/* Protected Routes */}
          <Route
            path="/landing"
            element={
              <ProtectedRoute>
                <Landing />
              </ProtectedRoute>
            }
          />

          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          {/*exercise1*/}
          {/* If the user navigates to /exercise1, React will render the <Exercise1 /> component. */}
          <Route path="/exercise1" element={<Exercise1 />} />
          <Route path="/exercise1intro" element={<Exercise1Intro />} />
          <Route path="/exercise1video" element={<Exercise1Video />} />
          <Route path="/exercise1failed" element={<Exercise1Failed />} />
          <Route path="/exercise2failed" element={<Exercise2Failed />} />
          <Route path="/exercise3failed" element={<Exercise3Failed />} />
          <Route path="/exercise4failed" element={<Exercise4Failed />} />
          <Route path="/exercise5failed" element={<Exercise5Failed />} />
          <Route path="/exercise7failed" element={<Exercise7Failed />} />
          <Route path="/exercise8failed" element={<Exercise8Failed />} />
          <Route path="/exercise9failed" element={<Exercise9Failed />} />
          <Route path="/exercise10failed" element={<Exercise10Failed />} />

          <Route
            path="/exercise1fullycomplete"
            element={<Exercise1FullyComplete />}
          />
          <Route
            path="/exercise2fullycomplete"
            element={<Exercise2FullyComplete />}
          />
          <Route
            path="/exercise3fullycomplete"
            element={<Exercise3FullyComplete />}
          />
          <Route
            path="/exercise4fullycomplete"
            element={<Exercise4FullyComplete />}
          />
          <Route
            path="/exercise5fullycomplete"
            element={<Exercise5FullyComplete />}
          />
          <Route
            path="/exercise7fullycomplete"
            element={<Exercise7FullyComplete />}
          />
          <Route
            path="/exercise8fullycomplete"
            element={<Exercise8FullyComplete />}
          />
          <Route
            path="/exercise9fullycomplete"
            element={<Exercise9FullyComplete />}
          />
          <Route
            path="/exercise10fullycomplete"
            element={<Exercise10FullyComplete />}
          />

          <Route path="/RhythmChoosing" element={<Exercise1Choosing />} />
          <Route path="/RhythmChoosingNoPopup" element={<Exercise1ChoosingNoPopup />} />
          <Route path="/exercise1workout" element={<Exercise1Workout />} />
          <Route path="/exercise1finish" element={<Exercise1Finish />} />
          <Route path="/exercise1summary" element={<Exercise1Summary />} />

          {/*exercise2*/}
          <Route path="/exercise2" element={<Exercise2 />} />
          <Route path="/exercise2intro" element={<Exercise2Intro />} />
          <Route path="/exercise2workout" element={<Exercise2Workout />} />
          <Route path="/exercise2finish" element={<Exercise2Finish />} />
          <Route path="/exercise2summary" element={<Exercise2Summary />} />

          {/*exercise3*/}
          <Route path="/exercise3" element={<Exercise3 />} />
          <Route path="/exercise3intro" element={<Exercise3Intro />} />
          <Route path="/exercise3workout" element={<Exercise3Workout />} />
          <Route path="/exercise3finish" element={<Exercise3Finish />} />
          <Route path="/exercise3summary" element={<Exercise3Summary />} />

          {/*exercise4*/}
          <Route path="/exercise4" element={<Exercise4 />} />
          <Route path="/exercise4intro" element={<Exercise4Intro />} />
          <Route path="/exercise4workout" element={<Exercise4Workout />} />
          <Route path="/exercise4summary" element={<Exercise4Summary />} />
          <Route path="/exercise4finish" element={<Exercise4Finish />} />

          {/*exercise5*/}
          <Route path="/exercise5" element={<Exercise5 />} />
          <Route path="/exercise5intro" element={<Exercise5Intro />} />
          <Route path="/exercise5workout" element={<Exercise5Workout />} />
          <Route path="/exercise5summary" element={<Exercise5Summary />} />
          <Route path="/exercise5finish" element={<Exercise5Finish />} />
          <Route path="/exercise5test" element={<Exercise5Test />} />

          {/*exercise6*/}
          <Route path="/exercise6" element={<Exercise6 />} />
          <Route path="/exercise6intro" element={<Exercise6Intro />} />
          <Route path="/exercise6workout" element={<Exercise6Workout />} />
          <Route path="/exercise6summary" element={<Exercise6Summary />} />

          {/*exercise7*/}
          <Route path="/exercise7" element={<Exercise7 />} />
          <Route path="/exercise7intro" element={<Exercise7Intro />} />
          <Route path="/exercise7workout" element={<Exercise7Workout />} />
          <Route path="/exercise7test" element={<Exercise7Test />} />
          <Route path="/exercise7summary" element={<Exercise7Summary />} />

          {/*exercise8*/}
          <Route path="/exercise8" element={<Exercise8 />} />
          <Route path="/exercise8intro" element={<Exercise8Intro />} />
          <Route path="/exercise8workout" element={<Exercise8Workout />} />
          <Route path="/exercise8test" element={<Exercise8Test />} />
          <Route path="/exercise8summary" element={<Exercise8Summary />} />
          <Route path="/exercise8warmup" element={<Exercise8Warmup />} />

          {/*exercise9*/}
          <Route path="/exercise9" element={<Exercise9 />} />
          <Route path="/exercise9intro" element={<Exercise9Intro />} />
          <Route path="/exercise9workout" element={<Exercise9Workout />} />
          <Route path="/exercise9test" element={<Exercise9Test />} />
          <Route path="/exercise9summary" element={<Exercise9Summary />} />

          {/*exercise10*/}
          <Route path="/exercise10" element={<Exercise10 />} />
          <Route path="/exercise10intro" element={<Exercise10Intro />} />
          <Route path="/exercise10workout" element={<Exercise10Workout />} />
          <Route path="/exercise10test" element={<Exercise10Test />} />
          <Route path="/exercise10summary" element={<Exercise10Summary />} />

          {/*warmup*/}
          <Route path="/Warmup1" element={<Warmup1 />} />
          <Route path="/Warmup2" element={<Warmup2 />} />
          <Route path="/Warmup3" element={<Warmup3 />} />
          <Route path="/Warmupwelcome" element={<Warmupwelcome />} />
          <Route path="/Warmupfinish" element={<Warmupfinish />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
